import { aiUrl } from "./common/apiKeys";
import axiosInstance from "./common/axiosInstance";

export type ChatMsg = { role: "user" | "assistant"; content: string };
export async function aiChat(messages: ChatMsg[]) {
  const res = await axiosInstance.post<{ reply: string }>(aiUrl, { messages });
  return res.data.reply;
}
